import React, { useContext, useState } from 'react';
import UserContext from '../../context/UserContext.js';
import CamposTorneoDatosBasicos from './campos/CamposTorneoDatosBasicos.js';
import CamposTorneoFechas from './campos/CamposTorneoFechas.js';
import * as DTOs from '../DTOs/TorneoDTOs.js';
import * as Funciones from '../funciones/FuncionesTorneo.js';
import CuadroEditable from '../UI/CuadroEditable.js';
import usePatchURL from '../../hooks/usePatchURL.js';

const CuadroEditableTorneo = (props) => {
  const cuadro = props.cuadro;
  const torneoOriginal = props.torneo;
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;
  const [torneo, setTorneo] = useState(props.torneo);
  const [editar, setEditar] = useState(puedeEditar && props.nuevo);
  const { isGrabando, erroresPatch, patchData, resetErroresPatch } = usePatchURL();

  const onCampoChange = (campo, valor) => {
    setTorneo(Funciones.OnCampoChange(torneo, campo, valor));
  };

  const datosGrabados = () => {
    setEditar(false);
    resetErroresPatch();
  };

  const botonEditarHandler = (event) => {
    if (editar) {
      setTorneo(torneoOriginal);
    }
    setEditar(!editar);
  };

  let titulo = null;
  let campos = null;
  switch (cuadro) {
    case Funciones.Cuadro.DATOS_BASICOS: {
      titulo = 'Datos básicos';
      campos = (
        <CamposTorneoDatosBasicos torneo={torneo} editar={editar} onCampoChange={onCampoChange} />
      );
      break;
    }
    case Funciones.Cuadro.FECHAS: {
      titulo = 'Fechas';
      campos = <CamposTorneoFechas torneo={torneo} editar={editar} onCampoChange={onCampoChange} />;
      break;
    }
    default: {
      throw new Error("Cuadro de datos '" + cuadro + "' no definido");
    }
  }

  const botonAceptarHandler = (event) => {
    if (!torneo.descripcion || torneo.descripcion === '') {
      alert('Debe indicar el nombre del torneo');
      return;
    }

    let dto;
    switch (cuadro) {
      case Funciones.Cuadro.DATOS_BASICOS: {
        dto = DTOs.patchTorneoDatosBasicos(torneo);
        break;
      }
      case Funciones.Cuadro.FECHAS: {
        dto = DTOs.patchTorneoFechas(torneo);
        break;
      }
      default: {
        throw new Error('DTO de ' + cuadro + ' no definido');
      }
    }
    patchData('torneos/' + torneo.id, dto, datosGrabados);
  };

  const botonCancelarHandler = (event) => {
    setTorneo(torneoOriginal);
    setEditar(false);
  };

  return (
    <CuadroEditable
      item={torneo}
      titulo={titulo}
      editar={editar}
      campos={campos}
      puedeEditar={puedeEditar}
      isGrabando={isGrabando}
      errores={erroresPatch}
      botonEditarHandler={botonEditarHandler}
      botonAceptarHandler={botonAceptarHandler}
      botonCancelarHandler={botonCancelarHandler}
    />
  );
};

export default CuadroEditableTorneo;
